export const STOPWORDS = [
  "a",
  "an",
  "and",
  "the",
  "to",
  "in",
  "of",
  "that",
  "this",
  "i",
  "your",
  "for",
  "with",
  "is",
  "on",
  "it",
  "as",
  "at",
  "from",
  "by",
  "was",
  "were",
  "be",
  "or",
  "which",
  "when",
  "where",
  "how",
  "who",
  "what",
  "why",
  "because",
  "about",
  "after",
  "all",
  "also",
  "am",
  "an",
  "any",
  "are",
  "arent",
  "as",
  "at",
  "b",
  "be",
  "because",
  "been",
  "being",
  "between",
  "both",
  "but",
  "by",
  "c",
  "cant",
  "come",
  "could",
  "couldnt",
  "d",
  "did",
  "didnt",
  "do",
  "does",
  "doesnt",
  "doing",
  "dont",
  "down",
  "during",
  "e",
  "each",
  "even",
  "f",
  "few",
  "for",
  "from",
  "further",
  "g",
  "get",
  "gets",
  "got",
  "h",
  "had",
  "has",
  "hasnt",
  "have",
  "havent",
  "having",
  "he",
  "hed",
  "hell",
  "her",
  "here",
  "heres",
  "hers",
  "herself",
  "hes",
  "him",
  "himself",
  "his",
  "how",
  "hows",
  "i",
  "id",
  "ill",
  "im",
  "ive",
  "if",
  "in",
  "into",
  "is",
  "it",
  "its",
  "itself",
  "j",
  "just",
  "k",
  "l",
  "let",
  "lets",
  "like",
  "likely",
  "m",
  "me",
  "more",
  "most",
  "must",
  "my",
  "myself",
  "n",
  "neither",
  "no",
  "nor",
  "not",
  "o",
  "of",
  "off",
  "often",
  "oh",
  "on",
  "once",
  "only",
  "or",
  "other",
  "ought",
  "our",
  "ours",
  "ourselves",
  "out",
  "over",
  "own",
  "p",
  "r",
  "rather",
  "s",
  "said",
  "same",
  "say",
  "says",
  "shant",
  "she",
  "shed",
  "shell",
  "shes",
  "should",
  "shouldnt",
  "since",
  "so",
  "some",
  "such",
  "t",
  "than",
  "that",
  "thats",
  "the",
  "their",
  "theirs",
  "them",
  "themselves",
  "then",
  "there",
  "theres",
  "these",
  "they",
  "theyd",
  "theyll",
  "theyre",
  "theyve",
  "this",
  "those",
  "through",
  "to",
  "too",
  "u",
  "under",
  "until",
  "up",
  "us",
  "v",
  "very",
  "w",
  "was",
  "we",
  "wed",
  "well",
  "were",
  "weve",
  "were",
  "werent",
  "what",
  "whats",
  "when",
  "whens",
  "where",
  "wheres",
  "which",
  "while",
  "who",
  "whos",
  "whom",
  "why",
  "whys",
  "with",
  "wont",
  "would",
  "wouldnt",
  "y",
  "you",
  "youd",
  "you",
  "x",
  "z",
  "cl",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "0"
];
